import React from "react";
import { BoxTabs } from "../../../../components/AntdTab/AntdTab";
import YourVendors from "../../YourVendors/YourVendors/YourVendors";
import FindVendors from "../../Vendors/FindVendors/FindVendors";
import { roles } from "../../../../config/roles";
import Storage from "../../../../utills/AsyncStorage";
import SubContacts from "../../Vendors/subContacts/SubContacts";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const items = [
  {
    key: "1",
    label: "Event Vendors",
    children: <YourVendors />,
  },
  {
    key: "2",
    label: "Find Vendors",
    children: <FindVendors />,
  },
];

const EventVendors = () => {
  const state = useLocation();
  console.log("eventvendorrr", state);
  
  const role = Storage.getERole("@role");
  const user = useSelector((state) => state.AuthReducer.user);
  const itemForVendor = [
    {
      key: "1",
      label: "Find Vendors",
      children: <FindVendors />,
    },
    {
      key: "2",
      label: "Event Vendors",
      children: <YourVendors />,
    },
    {
      key: "3",
      label: "My Staff",
      children: <SubContacts />,
    },
  ];

  if (user?.vendor_type == "individual") {
    itemForVendor.splice(2, 1);
  }

  return <BoxTabs items={role === roles.vendor ? itemForVendor : items} />;
};

export default EventVendors;
